import { FC, PropsWithChildren } from 'react';
import { Navigate } from 'react-router-dom';
import { isTokenValid } from 'shared/utils/functions';

const AuthGuard: FC<PropsWithChildren<unknown>> = ({ children }) => {
  if (!isTokenValid()) {
    return <Navigate to={'/login'} />;
  }
  return <>{children}</>;
};

export default AuthGuard;
